import {
  createContext,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

const MobileContext = createContext({} as boolean);
export const useMobile = () => useContext(MobileContext);
const useMobileProvider = () => {
  const [mobile, setMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };

    window.addEventListener("load", handleResize, true);
    window.addEventListener("resize", handleResize, true);

    return () => {
      window.removeEventListener("load", handleResize, true);
      window.removeEventListener("resize", handleResize, true);
    };
  }, []);

  return mobile;
};

export const MobileProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const mobile = useMobileProvider();
  return (
    <MobileContext.Provider value={mobile}>{children}</MobileContext.Provider>
  );
};
